import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { usePRD5011_R01Store } from "./Store_PRD5011_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PRD5011_R01 } from "./Content_PRD5011_R01";
import { SearchSection_PRD5011_R01 } from "./SearchSection_PRD5011_R01";
import { Table_PRD5011_R01 } from "./Table_PRD5011_R01";
import { ProductResultTable_PRD5011_R01 } from "./ProductResultTable_PRD5011_R01";
import { defaultPRD5011_R01Data, PRD5011_R01Dto, PRD5011_R01ProductResultDto } from "./Dto_PRD5011_R01";
import { useMouseContent } from "src/utils/mouse/mouseContent";

/**
 * KPI 전송 조회 컨테이너 컴포넌트
 * KPI 전송 조회 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_PRD5011_R01 = () => {
    const { 
        initData, 
    } = usePRD5011_R01Store();
    const { setMessage } = useUiuxStore();
    const kpiGridRef = useRef<AgGridReact<PRD5011_R01Dto>>(null);
    const productResultGridRef = useRef<AgGridReact<PRD5011_R01ProductResultDto>>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const isResizing = useRef(false);

    const RESIZER = {
        code: 'PRD5011_R01',
        type: 'height',
        storageKey: 'PRD5011_R01-split-height',
        min: 5,
        max: 80,
        default: 45,
        option: {
            browserMaxHeight: 95
        }
    } as const;

    const {
        fetchData,
        handleExcelClick,
        handleKpiSendClick,
        handleKpiSendAllClick,
        fetchProductResultByRow,
        clearProductResultData,
    } = Content_PRD5011_R01({
        setMessage,
    });

    const {
        splitValue,
        handleMouseDown,
    } = useMouseContent({
        resizer: RESIZER,
        isResizing,
        containerRef,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined} 
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={handleExcelClick}
                onPrintClick={() => {}}
            />
            
            <SearchSection_PRD5011_R01
                onKpiSendClick={handleKpiSendClick}
                onKpiSendAllClick={handleKpiSendAllClick}
            />
            
            <div className="flex-1 flex min-h-0 py-[5px] gap-[4px]">
                <div
                    className="flex flex-col flex-1 px-[12px] gap-[4px] min-h-0"
                    ref={containerRef}
                >
                    <div className="w-full min-h-0" style={{ height: `${splitValue}%` }}>
                        <Table_PRD5011_R01
                            gridRef={kpiGridRef}
                            defaultPRD5011_R01Row={defaultPRD5011_R01Data}
                            fetchProductResultByRow={fetchProductResultByRow}
                            clearProductResultData={clearProductResultData}
                        />
                    </div>
                    <div
                        className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 shrink-0"
                        onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent)}
                        onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
                    />
                    <div className="w-full min-h-0" style={{ height: `${100 - splitValue}%` }}>
                        <ProductResultTable_PRD5011_R01 gridRef={productResultGridRef} />
                    </div>
                </div>
            </div>
            
            <Message />
        </div>
    );
};
